export const AI_IMAGE_USER_ERROR_CODES = {
  CLIENT_IMAGE_META_REQUIRED: 'CLIENT_IMAGE_META_REQUIRED',
  UPSCALE_TARGET_TOO_SMALL: 'UPSCALE_TARGET_TOO_SMALL',
  UPSCALE_SOURCE_TOO_SMALL: 'UPSCALE_SOURCE_TOO_SMALL',
  UPSCALE_SOURCE_TOO_SMALL_FOR_TARGET: 'UPSCALE_SOURCE_TOO_SMALL_FOR_TARGET',
  UPSCALE_TRANSPARENT_IMAGE_TOO_LARGE: 'UPSCALE_TRANSPARENT_IMAGE_TOO_LARGE',
  INPUT_IMAGE_TOTAL_TOO_LARGE: 'INPUT_IMAGE_TOTAL_TOO_LARGE',
  INPUT_IMAGE_SIZE_UNKNOWN: 'INPUT_IMAGE_SIZE_UNKNOWN',
  INPUT_IMAGE_TOO_LARGE_SINGLE: 'INPUT_IMAGE_TOO_LARGE_SINGLE',
  INPUT_IMAGE_DIMENSIONS_TOO_SMALL: 'INPUT_IMAGE_DIMENSIONS_TOO_SMALL',
  INPUT_IMAGE_COUNT_EXCEEDED: 'INPUT_IMAGE_COUNT_EXCEEDED',
  INPUT_IMAGE_NOT_OWNED: 'INPUT_IMAGE_NOT_OWNED',
  INPUT_IMAGE_NOT_FOUND: 'INPUT_IMAGE_NOT_FOUND',
  FEATURE_NOT_SUPPORTED: 'FEATURE_NOT_SUPPORTED',
  FEATURE_REQUIRES_AUTH: 'FEATURE_REQUIRES_AUTH',
  FEATURE_REQUIRES_PAID: 'FEATURE_REQUIRES_PAID',
} as const;

export type AiImageUserErrorCode =
  (typeof AI_IMAGE_USER_ERROR_CODES)[keyof typeof AI_IMAGE_USER_ERROR_CODES];

export class AiImageUserInputError extends Error {
  code: AiImageUserErrorCode;

  constructor(message: string, code: AiImageUserErrorCode) {
    super(message);
    this.name = 'AiImageUserInputError';
    this.code = code;
  }
}

export function isAiImageUserInputError(
  error: unknown
): error is AiImageUserInputError {
  return error instanceof AiImageUserInputError;
}
